import React, { useState, useEffect, useRef } from "react"
import { Box, Typography, DialogActions, DialogContent, Grid, Tooltip } from "@mui/material"
import TextInputComponent from "../../atom/Inputs/TextInput"
import TextButtonComponet from "../../atom/Buttons/TextButton"
import { MINIMUM_PASSWORD_CHARACTERS, USER_ROLE, EMAIL_REGEX, getText, getDeviceId, PASSWORD_REGEX, onGetCurrencySymble, COURSE_TYPE_LIST, setText, THEME_COLORS, DEFAULT_CURRENCY, APPROXIMATESIGN } from "../../../core/Constant";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Actions } from "../../../core/modules/Actions";
import CardValidator from 'card-validator';
import _ from "lodash";
import SignUpFormOne from "./SignUpFormOne";
import SignUpFormTwo from "./SignUpFormTwo";
import SecondStep from "../../../assets/Images/activeSlider.png";
import SecondOne from "../../../assets/Images/Signupgroup.png";
import DropDownComponent from "../../atom/Inputs/DropDown";
import {
    PaymentElement,
    Elements,
    useStripe,
    useElements,
    CardElement
} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import { stripeKey } from "../../../core/repository/Repository";
import moment from "moment";
import { RadioButtonComponent } from "../../atom";

const stripePromise = loadStripe(stripeKey);

const SignUpForm = ({ onClose = () => { }, paymentsheet = true, item = {}, stepIndex = 0, isRegistered = false, currencyId, cardSelectedPlan = {}, isViewMorePlans = false, selectedCurrencyOp = {} }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isShowApproxiSign = selectedCurrencyOp?.currency !== DEFAULT_CURRENCY
    
    const [selectedPlan, setSelectedPlan] = useState("")
    const [formOneData, setFormOneData] = useState({});
    const [payment, setPayment] = useState(false);
    const formOneRef = useRef();
    const formTwoRef = useRef();
    const [step, setStep] = useState(0);
    const [course, setCourse] = useState({});
    const [isFree, setIsFree] = useState(0);
    const [isMultiBatch, setIsMultiBatch] = useState("");
    const [isLoading, setLoading] = useState(false);

    const [courseType, setCourseType] = useState(COURSE_TYPE_LIST[0]?.id);
    const [planCurrencyId, setPlanCurrencyId] = useState("")
    const [courseTypeList, setCourseTypeList] = useState(COURSE_TYPE_LIST);
    const [price, setPrice] = useState(0)
    const [priceKey, setPriceKey] = useState()
    const [duration, setDuration] = useState("")

    const [type, setType] = useState(1);
    const [isEmailVerified, setIsEmailVerified] = useState(false);

    const loadingAction = useSelector(state => state.common.get('loadingAction'));
    const currency = localStorage.getItem('GlobalCurrency')
    const [symbol, setSymbol] = useState();
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [isPromo, setIsPromo] = useState(false);

    const [isShow, setIsShow] = useState(0);
    const show = useSelector(state => state.common.get('show'));

    useEffect(() => {
        setIsShow(show == 1);
    }, [show]);


    useEffect(()=>{
      if(cardSelectedPlan?.id !== selectedPlan?.id || cardSelectedPlan?.currency_id !== selectedPlan?.currency_id){
        setSelectedPlan(cardSelectedPlan)
      }
    },[cardSelectedPlan])


    useEffect(() => {
        const { action, loading } = loadingAction;
        const type = action.type;
        if (type == "SIGN_UP" || type == 'ENROLL_NEW_COURSE_BY_REGISTERED_USER') {
            setLoading(loading)
        }
    }, [loadingAction]);

    useEffect(() => {
        setStep(stepIndex);
    }, [stepIndex, isRegistered]);

    useEffect(()=>{},[item]);

    useEffect(() => {
        setCourse(item);
        const cType = item?.course_type;
        setType(cType);
        setIsFree(item?.is_free);
        setIsMultiBatch(item?.is_multi_batch)
        setIsPromo(false)
        if (item?.course_currencies && selectedPlan) {
            const plan = item?.course_currencies?.find((cc)=> cc?.id?.toString() === selectedPlan?.id?.toString() )
            setSelectedPlan(plan)
            if (plan) {
                const currencySymbol = onGetCurrencySymble(_.get(plan, "currency.currency"));
                const price =  _.get(plan, "price", "");
                setPlanCurrencyId(plan?.id)
                setPrice(price)
                setPriceKey(plan?.price_key)
                setSymbol(currencySymbol);
                setSelectedCurrency(plan)
                if(item?.duration !== null ){
                   setDuration(item?.duration?.toString())
                } else {
                   setDuration(plan?.duration_weeks?.toString())
                }
                // return `${currencySymbol}${price}`;
            } else {
                // selected type not available
                const selectedCurrency = item.course_currencies[0]
                const currencySymbol = onGetCurrencySymble(_.get(selectedCurrency, "currency.currency"));
                const price = _.get(selectedCurrency, "price", "");
                setPlanCurrencyId(selectedCurrency?.id)
                setPrice(price)
                setPriceKey(selectedCurrency?.price_key)
                setSymbol(currencySymbol);
                setSelectedCurrency(selectedCurrency)
                if(item?.duration !== null){
                   setDuration(item?.duration?.toString())
                } else {
                   setDuration(selectedPlan?.duration_weeks?.toString())
                }
            }
        }
    },[currency,item,selectedPlan]);
    


    const onNext = () => {
        setPayment(true);
        formOneRef.current.onPress()
    }

    const onCloseForm = () => {
        setStep(stepIndex)
        onClose()
    }



    const onSignUp = () => {
        formTwoRef.current.onPress(price, courseType)
    }

    const onUpdateValue = (value, type) => {
        if (type == 0) {
            setIsPromo(false)
        }
        if (type == 1) {
            setIsPromo(true)
            // setPrice(value)
        }
        if(type === 3){
          setIsPromo(false)
        }
    }

    const onFreeCource = async (data) => {
        const device_id = await getDeviceId();
        dispatch(Actions.auth.signUp({ 
            ...data, 
            device_id, 
            currency_id: currency, 
          course_currency_id: selectedPlan?.id,
            course_id: item?.id,
         }));
    }

    const handleRadioChange = (event) => {
     const text = getText(event);
     const selectedPlan = item?.course_currencies?.find((plan) => plan?.id?.toString() === text?.toString());
     setSelectedPlan(selectedPlan);
    };

    return (
        <>
            <form >
                <DialogContent>
                    <Box>
                        {
                            isViewMorePlans && <Box>
                                <Grid
                                  container
                                  sx={{
                                    bgcolor: THEME_COLORS.gray4,
                                    borderRadius: 2,
                                  }}
                                  mb={3}
                                >
                                {
                                    item?.course_currencies?.map((plan)=>{
                                        const planName = plan?.plan_name
                                          const needsTooltip = planName?.length > 40
                                          const displayedText = needsTooltip
                                             ? `${planName?.substring(0, 40)}...`
                                             : planName;
                                        return (
                                            <Grid item xs={12} display={"flex"} alignItems={"center"}>
                                               <RadioButtonComponent
                                                 checked={selectedPlan?.id?.toString() === plan?.id?.toString()}
                                                 value={plan?.id}
                                                 handleChange={handleRadioChange}
                                               />
                      
                                               <span
                                                 style={{
                                                   fontFamily: "Montserrat, sans serif",
                                                   fontSize: "15px",
                                                   padding: 0,
                                                   margin: 0,
                                                   marginRight:5,
                                                   color:"#2d3945"
                                                 }}
                                               >
                                                {needsTooltip ? (
                                                  <Tooltip title={planName} placement="top" arrow>
                                                    <span style={{ cursor: "pointer" }}>
                                                      {displayedText}
                                                    </span>
                                                  </Tooltip>
                                                ) : (
                                                  displayedText
                                                )}  
                                               </span>

                                                <span
                                                  style={{
                                                    fontFamily: "Montserrat",
                                                    fontWeight: 800,
                                                    fontSize: 15,
                                                    color: "#2d3945",
                                                  }}
                                                >
                                                  {` - ${moment()
                                                    .month(Number(plan?.batch_month) - 1)
                                                    .format("MMMM")} ${plan?.batch_year}`}
                                                </span>
                                           </Grid>
                                        )
                                    })
                                }
                                </Grid>
                            </Box>
                        }
                      <Box className='signup-price-container' sx={{
                                      marginBottom: "50px",
                        }}>
                        <Grid  container>
                            <Grid xs={6} item>
                                <Box>
                                    <div className="signup-price-subtext">Selected course</div>
                                    <div className="signup-price-text">{_.get(course, 'name', '')}</div>
                                </Box>
                            </Grid>
                          {isShow?  <Grid xs={6} item>
                                <Box
                                  sx={{
                                       display: "flex",
                                       flexDirection: "column",
                                       justifyContent: "flex-end",
                                       alignItems: "flex-end",
                                      }}
                                 >
                                <Box>
                                  <Typography
                                    component={"span"}
                                    style={{ color: "#4a6375" }}
                                    className="signup-price-title"
                                  >
                                    Price
                                  </Typography>
                                </Box>
                                <Box>
                                  <Typography
                                    component={"span"}
                                    className="signup-price-title"
                                    sx={{
                                      color: THEME_COLORS.primaryLight2,
                                      fontWeight: 800,
                                      fontSize: "22px",
                                      textDecoration: isPromo ? "line-through" : "none",
                                    }}
                                  >
                                    {`${price && isShowApproxiSign ? APPROXIMATESIGN : "" }${symbol}${price}`}
                                  </Typography>
                                </Box>
                              </Box>
                            </Grid>: null}
                        </Grid>
                        <Grid container mt={1}>
                              <Grid xs={8} item>
                                {selectedPlan && isFree === 0 && (
                                  <Box>
                                    <div className="signup-price-subtext">Plan</div>
                                    <div className="signup-price-text">
                                      {selectedPlan?.plan_name}
                                      <span
                                        className="signup-price-text"
                                      >
                                        { selectedPlan?.plan_name ? " -" : ""  }
                                        {` ${selectedPlan?.batch_month ? moment()
                                          .month(Number(selectedPlan?.batch_month) - 1)
                                          .format("MMMM") : "" } ${selectedPlan?.batch_year ? selectedPlan?.batch_year : ""}`}
                                      </span>
                                    </div>
                                  </Box>
                                )}
                              </Grid>
                              <Grid xs={4} item>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "flex-end",
                                      alignItems: "flex-end",
                                    }}
                                  >
                                  </Box>
                              </Grid>
                        </Grid>
                        </Box>
                        
                        <Box>
                        {isShow?  <Box sx={{ width: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 5 }}>
                                <Box
                                    component="img"
                                    sx={{
                                        height: 0.6,
                                        width: 0.6,
                                        alignSelf: 'center',
                                        display: 'flex',
                                    }}
                                    alt="The house from the offer."
                                    src={step == 0 ? SecondOne : SecondStep}
                                />

                            </Box>:null}
                            <>
                                {step == 0 && !isRegistered ?
                                    <SignUpFormOne
                                        courseType={courseType}
                                        isFree={isFree || !isShow}
                                        selectedCurrency={selectedCurrency}
                                        course_id={_.get(course, 'id', '')}
                                        onEmailVerified={() => setIsEmailVerified(true)}
                                        onPassValue={(data) => {
                                            if (isFree || !isShow) {
                                                onFreeCource(data)
                                            } else {
                                                setFormOneData({ ...data });
                                                setStep(1)
                                            }
                                        }}
                                        ref={formOneRef} /> :
                                        <Elements stripe={stripePromise}>
                                    <SignUpFormTwo
                                        onUpdateValue={onUpdateValue}
                                        item={formOneData}
                                        course_id={_.get(course, 'id', '')}
                                        onClose={onCloseForm}
                                        isRegistered={isRegistered}
                                        courseType={courseType}
                                        planCurrencyId={planCurrencyId}
                                        priceKey={priceKey}
                                        symbol={symbol}
                                        ref={formTwoRef} />
                                        </Elements>
                                }
                               
                            </>

                        </Box>

                    </Box>
                </DialogContent>
                {/* Only show actions if email is verified or it's not the first step */}
                {(isEmailVerified || step !== 0) && (
                    <DialogActions sx={{ padding: 4 }}>
                        {step == 0 && !isRegistered ? (
                            <Box sx={{ display: "flex", gap: 5, width: 1, justifyContent: 'center' }}>
                                <TextButtonComponet 
                                    text={"Cancel"} 
                                    classStyle="btn btn-secondary" 
                                    width={120} 
                                    isDisabled={isLoading}
                                    onButtonClick={onCloseForm} 
                                />
                                <TextButtonComponet 
                                    text={isFree || !isShow ? "Sign up" : "Next"} 
                                    isDisabled={isLoading}
                                    onButtonClick={onNext} 
                                    width={120} 
                                />
                            </Box>
                        ) : (
                            <Box sx={{ display: "flex", gap: 5, width: 1, justifyContent: 'center' }}>
                                <TextButtonComponet 
                                    text={"Cancel"} 
                                    classStyle="btn btn-secondary" 
                                    width={120} 
                                    isDisabled={isLoading}
                                    onButtonClick={onCloseForm} 
                                />
                                {!isLoading ? (
                                <TextButtonComponet 
                                    text={"Proceed"} 
                                    width={120} 
                                    onButtonClick={onSignUp} 
                                />
                                ) : (
                                    <TextButtonComponet 
                                        isDisabled={true} 
                                        text={"Processing..."} 
                                        width={120} 
                                    />
                                )}
                            </Box>
                        )}
                    </DialogActions>
                )}
            </form>

        </>
    )
}

export default SignUpForm;